module.exports = __webpack_public_path__ + "static/media/0235_Small.71ec4d8c.jpg";